import classNames from 'classnames';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const BaseCallout = forwardRef((props, ref) => {
	const {
		dataTestId = 'callout',
		message,
		icon,
		onClick,
		calloutClassName,
		disabled,
		calloutType,
		...calloutProps
	} = props;

	const calloutClass = classNames('DS_callout', 'callout-wrapper', calloutClassName, {
		'DS_callout--disabled': disabled
	});

	return (
		<div
			ref={ref}
			className={calloutClass}
			data-testid={dataTestId}
			onClick={(e) => {
				if (!disabled && onClick) {
					onClick(e);
				}
			}}
			onKeyDown={(e) => {
				if (!disabled && onClick && (e.key === 'Enter' || e.key === ' ')) {
					onClick(e);
				}
			}}
			role="button"
			tabIndex="0"
			{...calloutProps}
		>
			<div className="callout-content">
				{icon && <span className="callout-icon">{icon}</span>}
				{message && <span className="callout-message">{message}</span>}
			</div>
		</div>
	);
});

BaseCallout.displayName = 'BaseCallout';

BaseCallout.defaultProps = {
	dataTestId: PropTypes.string,
	message: PropTypes.string,
	icon: PropTypes.node,
	onClick: PropTypes.func,
	calloutClassName: PropTypes.string,
	disabled: PropTypes.bool,
	calloutType: PropTypes.oneOf(['INFO', 'WARNING', 'ERROR']),
};

export default BaseCallout;